import React from 'react';
import {compose} from "redux";
import {withTranslation} from "react-i18next";


class ASAYAupdatesComposed extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isMore: false
        }
    }


    changeIsMore = () => {
        let val = !this.state.isMore
        this.setState({isMore: val} );
    }

    render() {
        let {t} = this.props

        return (
            <div>
                <div className={'bottom-page-asaya-updates'}>
                    <div className={'adminFonts'}> {t('doctor.ASAYA_updates')}</div>
                    <button className={'button6'} onClick={this.changeIsMore} > {t('doctor.all_updates')}</button>
                </div>
                <div className={'asayaContainer'}>
                    <div className={'asayaInnerContainer'}>
                        <div className={'asayaTwoLeftContainers'}>
                            <div className={'asayaTextContainer'}>
                                <div className={'asayaTitle'}>
                                    Lorem ipsum dolor sit amet
                                </div>
                                <div className={'asayaDate'}>
                                    20/10/2020
                                </div>
                                <div className={'asayaContent'}>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor.
                                </div>
                            </div>
                        </div>
                        <div className={'asayaTwoLeftContainers'}>
                            <div className={'asayaTextContainer'}>
                                <div className={'asayaTitle'}>
                                    Lorem ipsum dolor sit amet
                                </div>
                                <div className={'asayaDate'}>
                                    20/10/2020
                                </div>
                                <div className={'asayaContent'}>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor.
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sodales pulvinar sic tempor. Proin sodales pulvinar sic tempor.
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
const ASAYAupdates = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(ASAYAupdatesComposed);

export default ASAYAupdates;
